import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthorizationService } from '../services/data/request/auth.service';


@Injectable({
  providedIn: 'root'
})

/**
 * Guard to activate a guarded route depending on role
 */
export class RoleGuard implements CanActivate {
  constructor(public authService: AuthorizationService, public router: Router) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole: string = 'tenantadmin';
    const redirectUrl = route['_routerState']['url'];

    const user = this.authService.getAuthUser();
    if (user && !user.roles && !user.roles.some(role => role.name === expectedRole)) {
      return true;
    }

    this.router.navigateByUrl(
      this.router.createUrlTree(
        ['login'], {
          queryParams: {
            redirectUrl
          }
        }
      )
    );

    return false;
  }
}


